















import {
  Component,
  Vue,
  Watch,
  Prop,
  Emit,
  Model,
} from 'vue-property-decorator';

@Component
export default class Collapse extends Vue {
  // 启用折叠面板，只展示一个面板
  @Prop({default: false, required: false}) private accordion!: any;
  @Prop({default: () => [], required: false}) private length!: any[];
  @Prop({required: false}) private active!: any;
  @Prop({default: () => [], required: false}) private actives!: any;
  @Prop({required: false, default: false}) private tree!: boolean;

  private activeName: string = '';
  private activeNames: any[] = [];
  private hehe: boolean = false;

  private created() {
    // 只展开一个折叠面板
    this.activeName = this.active;
    // 初始化时，同时展开多个折叠面板
    this.activeNames = this.actives;
    const that = this;
    setTimeout(() => {
      that.tree = false;
    }, 500);
  }
}
